import { CampoValor } from "../../types";
import { TableContainer } from "../../styles";
import styled from "styled-components";

const StyledTableContainer = styled(TableContainer)`
    .data-table {
        tbody {
            tr {
                td {
                    &.before-cell {
                        color: var(--c64748b) !important;
                    }

                    &.after-cell {
                        color: var(--c000000) !important;
                        padding-left: 8px !important;
                    }
                }
            }
        }
    }
`;


interface BlocoAlteracoesProps {
    campos: CampoValor[];
    esconderTitulo?: boolean;
}

export default function BlocoAlteracoes({ campos, esconderTitulo = false }: BlocoAlteracoesProps) {
    const camposAlteracoes = campos.filter(c => c.campo.includes('Antes') || c.campo.includes('Depois'));
    
    if (camposAlteracoes.length === 0) {
        return null;
    }

    // Agrupar campos "Antes" e "Depois" pelo nome base do campo
    const camposAgrupados = new Map<string, { antes?: string; depois?: string }>();
    
    camposAlteracoes.forEach(campo => {
        const nomeBase = campo.campo.replace(' (Antes)', '').replace(' (Depois)', '');
        
        if (!camposAgrupados.has(nomeBase)) {
            camposAgrupados.set(nomeBase, {});
        }
        
        const grupo = camposAgrupados.get(nomeBase)!;
        
        if (campo.campo.includes('Antes')) {
            grupo.antes = campo.valor;
        } else if (campo.campo.includes('Depois')) {
            grupo.depois = campo.valor;
        }
    });
    
    const camposFormatados = Array.from(camposAgrupados.entries())
        .filter(([_, grupo]) => grupo.antes !== undefined || grupo.depois !== undefined)
        .map(([campo, grupo]) => ({
            campo,
            antes: grupo.antes || '—',
            depois: grupo.depois || '—'
        }));

    if (camposFormatados.length === 0) {
        return null;
    }

    return (
        <div className="expanded-section">
            {!esconderTitulo && <h4 className="section-title">Alterações</h4>}
            <StyledTableContainer>
                <table className="data-table">
                    <thead>
                        <tr>
                            <th className="field-col">Campo</th>
                            <th className="before-col">Antes</th>
                            <th className="after-col">Depois</th>
                        </tr>
                    </thead>
                    <tbody>
                        {camposFormatados.map((campo, i) => (
                            <tr key={i} className={i > 0 ? 'border-top' : ''}>
                                <td className="field-cell">{campo.campo}</td>
                                <td className={`before-cell ${campo.antes === '—' ? 'empty-value' : ''}`}>
                                    {campo.antes}
                                </td>
                                <td className={`after-cell ${campo.depois === '—' ? 'empty-value' : ''}`}>
                                    {campo.depois}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </StyledTableContainer>
        </div>
    );
}

